<script setup>
import Icon from '@/Components/Images/Icon.vue';
import arrow from '@i/arrow-down.svg';
import { Link } from '@inertiajs/vue3';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { ref } from 'vue';
const props = defineProps({
    title: String,
    childItems: Array,
});

const breakpoints = useBreakpoints(breakpointsTailwind);
const onMobile = breakpoints.smaller('lg');

const showSubMenu = ref(false);

function onMouseEnter() {
    if (onMobile.value) {
        return;
    }
    showSubMenu.value = true;
}

function onMouseLeave() {
    if (onMobile.value) {
        return;
    }
    showSubMenu.value = false;
}
</script>

<template>
    <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" class="relative">
        <span @click="showSubMenu = !showSubMenu"
            class="relative flex items-center w-full gap-4 px-6 py-3 cursor-pointer lg:mt-2 lg:hover:bg-primary lg:bg-gray-lighter lg:hover:text-primary-text">
            {{ title }}

            <Icon class="flex items-center w-4 h-4 transition-all" :class="{ '-rotate-180': showSubMenu }" :icon="arrow"
                alt="icon" />
        </span>
        <div v-show="showSubMenu" class="top-0 w-full ml-6 lg:ml-0 lg:-translate-x-full lg:absolute">
            <ul>
                <li v-for="(item, i) in childItems" :key="i">
                    <Link v-if="item.type.includes('MenuItem') && item.data.url" :key="i"
                        class="block w-full px-6 py-3 select-none bg-gray-lighter lg:hover:bg-primary lg:hover:text-primary-text"
                        :href="item.data.url">
                    <span class="flex items-center gap-2">
                        {{ item.data.title }}
                    </span>
                    </Link>
                    <a v-if="item.type.includes('ExternalLink')" :key="i"
                        class="block w-full px-6 py-3 bg-gray-lighter lg:hover:bg-primary lg:hover:text-primary-text"
                        :href="item.data.url" target="_blank">
                        <span class="flex items-center gap-2">
                            {{ item.data.title }}
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
